import Dialog from './Dialog';
Dialog.install = (Vue)=>{
    Vue.components(Dialog.name,Dialog)
}
export default Dialog;
